import _regeneratorRuntime from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __await = this && this.__await || function (v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
};

var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};

var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;

  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }

  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }

  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }

  function fulfill(value) {
    resume("next", value);
  }

  function reject(value) {
    resume("throw", value);
  }

  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
};

import { visit } from 'graphql';
import { meros } from 'meros';
import { isAsyncIterable, makeAsyncIterableIteratorFromSink } from '@n1ru4l/push-pull-async-iterable-iterator';

var errorHasCode = function errorHasCode(err) {
  return typeof err === 'object' && err !== null && 'code' in err;
};

export var isSubscriptionWithName = function isSubscriptionWithName(document, name) {
  var isSubscription = false;
  visit(document, {
    OperationDefinition: function OperationDefinition(node) {
      var _a;

      if (name === ((_a = node.name) === null || _a === void 0 ? void 0 : _a.value)) {
        if (node.operation === 'subscription') {
          isSubscription = true;
        }
      }
    }
  });
  return isSubscription;
};
export var createSimpleFetcher = function createSimpleFetcher(options, httpFetch) {
  return function (graphQLParams, fetcherOpts) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return httpFetch(options.url, {
                method: 'POST',
                body: JSON.stringify(graphQLParams),
                headers: Object.assign(Object.assign({
                  'content-type': 'application/json'
                }, options.headers), fetcherOpts === null || fetcherOpts === void 0 ? void 0 : fetcherOpts.headers)
              });

            case 2:
              data = _context.sent;
              return _context.abrupt("return", data.json());

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
export var createWebsocketsFetcherFromUrl = function createWebsocketsFetcherFromUrl(url, connectionParams) {
  var wsClient;

  try {
    var _require = require('graphql-ws'),
        createClient = _require.createClient;

    wsClient = createClient({
      url: url,
      connectionParams: connectionParams
    });
    return createWebsocketsFetcherFromClient(wsClient);
  } catch (err) {
    if (errorHasCode(err)) {
      if (err.code === 'MODULE_NOT_FOUND') {
        throw Error("You need to install the 'graphql-ws' package to use websockets when passing a 'subscriptionUrl'");
      }
    }

    console.error("Error creating websocket client for:\n".concat(url, "\n\n").concat(err));
  }
};
export var createWebsocketsFetcherFromClient = function createWebsocketsFetcherFromClient(wsClient) {
  return function (graphQLParams) {
    return makeAsyncIterableIteratorFromSink(function (sink) {
      return wsClient.subscribe(graphQLParams, Object.assign(Object.assign({}, sink), {
        error: function error(err) {
          if (err instanceof CloseEvent) {
            sink.error(new Error("Socket closed with event ".concat(err.code, " ").concat(err.reason || '').trim()));
          } else {
            sink.error(err);
          }
        }
      }));
    });
  };
};
export var createLegacyWebsocketsFetcher = function createLegacyWebsocketsFetcher(legacyWsClient) {
  return function (graphQLParams) {
    var observable = legacyWsClient.request(graphQLParams);
    return makeAsyncIterableIteratorFromSink(function (sink) {
      return observable.subscribe(sink).unsubscribe;
    });
  };
};
export var createMultipartFetcher = function createMultipartFetcher(options, httpFetch) {
  return function (graphQLParams, fetcherOpts) {
    return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var e_1, _a, response, response_1, response_1_1, chunk, message;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __await(httpFetch(options.url, {
                method: 'POST',
                body: JSON.stringify(graphQLParams),
                headers: Object.assign(Object.assign({
                  'content-type': 'application/json',
                  accept: 'application/json, multipart/mixed'
                }, options.headers), fetcherOpts === null || fetcherOpts === void 0 ? void 0 : fetcherOpts.headers)
              }).then(function (response) {
                return meros(response, {
                  multiple: true
                });
              }));

            case 2:
              response = _context2.sent;

              if (isAsyncIterable(response)) {
                _context2.next = 13;
                break;
              }

              _context2.t0 = __await;
              _context2.next = 7;
              return __await(response.json());

            case 7:
              _context2.next = 9;
              return _context2.sent;

            case 9:
              _context2.t1 = _context2.sent;
              _context2.next = 12;
              return (0, _context2.t0)(_context2.t1);

            case 12:
              return _context2.abrupt("return", _context2.sent);

            case 13:
              _context2.prev = 13;
              response_1 = __asyncValues(response);

            case 15:
              _context2.next = 17;
              return __await(response_1.next());

            case 17:
              response_1_1 = _context2.sent;

              if (response_1_1.done) {
                _context2.next = 29;
                break;
              }

              chunk = response_1_1.value;

              if (!chunk.some(function (part) {
                return !part.json;
              })) {
                _context2.next = 23;
                break;
              }

              message = chunk.map(function (part) {
                return "Headers::\n".concat(part.headers, "\n\nBody::\n").concat(part.body);
              });
              throw new Error("Expected multipart chunks to be of json type. got:\n".concat(message));

            case 23:
              _context2.next = 25;
              return __await(chunk.map(function (part) {
                return part.body;
              }));

            case 25:
              _context2.next = 27;
              return _context2.sent;

            case 27:
              _context2.next = 15;
              break;

            case 29:
              _context2.next = 34;
              break;

            case 31:
              _context2.prev = 31;
              _context2.t2 = _context2["catch"](13);
              e_1 = {
                error: _context2.t2
              };

            case 34:
              _context2.prev = 34;
              _context2.prev = 35;

              if (!(response_1_1 && !response_1_1.done && (_a = response_1.return))) {
                _context2.next = 39;
                break;
              }

              _context2.next = 39;
              return __await(_a.call(response_1));

            case 39:
              _context2.prev = 39;

              if (!e_1) {
                _context2.next = 42;
                break;
              }

              throw e_1.error;

            case 42:
              return _context2.finish(39);

            case 43:
              return _context2.finish(34);

            case 44:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[13, 31, 34, 44], [35,, 39, 43]]);
    }));
  };
};
export var getWsFetcher = function getWsFetcher(options) {
  if (options.wsClient) {
    return createWebsocketsFetcherFromClient(options.wsClient);
  }

  if (options.subscriptionUrl) {
    return createWebsocketsFetcherFromUrl(options.subscriptionUrl, options.wsConnectionParams);
  }

  var legacyWebsocketsClient = options.legacyClient || options.legacyWsClient;

  if (legacyWebsocketsClient) {
    return createLegacyWebsocketsFetcher(legacyWebsocketsClient);
  }
};